<template>
  <div class="feedback-box content">
    <div v-if="items.length === 0" class="empty-state">
      <p class="text-muted text-center py-4">No grammar issues found</p>
    </div>

    <grammar-flags-base-items
      v-else
      :grouped-items="filteredGroupedItems"
      :types="types"
      :is-no-ranges="isNoRanges"
      :active-highlight-index="activeHighlightIndex"
      next-step-title="Suggestions:"
      @updateActiveHighlightIndex="$emit('updateActiveHighlightIndex', $event)"
      @updateHighlights="$emit('updateHighlights', $event)"
    />
  </div>
</template>

<script>
import GrammarFlagsBaseItems from "@/components/essay/essay/v3/grammar_flags_base_items.vue";
import generateBaseReportV3Mixin from "@/components/essay/essay/v3/mixins/base_report_v3";
import { ERROR_BREAKDOWN_TYPES } from "@/constants";

export default {
  components: {
    GrammarFlagsBaseItems,
  },

  // this.activeHighlightIndex
  // this.items
  // this.essay
  // this.isNoRanges
  // this.deleteEssayTabData
  // this.updateEssay
  // this.selectedItem
  // this.selectItem
  mixins: [generateBaseReportV3Mixin("grammar")],

  data() {
    return {
      types: ERROR_BREAKDOWN_TYPES,
    };
  },
  computed: {
    specialForCopyPaste() {
      return this._provided.specialForCopyPaste;
    },

    itemsWithColors() {
      return this.items.map((item) => ({
        ...item,
        color: this.types[item.type].color,
        backgroundColor: this.types[item.type].background,
      }));
    },

    reportItems() {
      return Object.keys(this.groupedItems).map((type) => ({
        id: type,
        criteria: {
          name: this.types[type].title,
        },
        color: this.types[type].color,
        backgroundColor: this.types[type].background,
      }));
    },

    groupedItems() {
      return this.items.reduce((groupedItems, item) => {
        if (!groupedItems[item.type]) {
          groupedItems[item.type] = [];
        }

        groupedItems[item.type].push({
          ...item,
          analysis: item.analysis,
        });

        return groupedItems;
      }, {});
    },

    filteredGroupedItems() {
      if (this.selectedItem === "all") {
        return this.groupedItems;
      }

      return {
        [this.selectedItem]: this.groupedItems[this.selectedItem],
      };
    },
  },

  watch: {
    groupedItems: {
      handler(newGroupedItems) {
        // If current selected type no longer exists, switch to first available or 'all'
        if (
          this.selectedItem !== "all" &&
          !newGroupedItems[this.selectedItem]
        ) {
          const availableTypes = Object.keys(newGroupedItems);
          this.selectItem(
            availableTypes.length > 0 ? availableTypes[0] : "all"
          );
        }
      },
      deep: true,
    },
  },

  created() {
    const unwatch = this.$watch("groupedItems", () => {
      if (this.items.length === 0) return;

      this.selectItem(
        this.specialForCopyPaste
          ? "all"
          : Object.keys(this.groupedItems)[0] || "all"
      );
      unwatch();
    });
  },

  methods: {
    // NOTE: needed for mixin, avoid get this.selectedItem from items array
    init() {},
  },
};
</script>

<style lang="scss" scoped>
.feedback-box.ql-container {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: none;
  padding-top: 0px;
}

.feedback-items {
  border-top: none;
}
</style>
